module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mailing-list/component/home-main-modal-customer/home-main-modal-customer.component.sass
// module id = ./src/app/modules/mailing-list/component/home-main-modal-customer/home-main-modal-customer.component.sass
// module chunks = main